export const destroy = (self) => {
  if (self._touchStartOnCanvasElHandler != null) {
    self._canvas_el?.removeEventListener(
      "touchstart",
      self._touchStartOnCanvasElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnCanvasElHandler = null;
  }
  if (self._touchStartOnSelectorPathElHandler != null) {
    self._selector_path_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorPathElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorPathElHandler = null;
  }
  if (self._touchStartOnSelectorScaleNCircleElHandler != null) {
    self._selector_n_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorScaleNCircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorScaleNCircleElHandler = null;
  }
  if (self._touchStartOnSelectorScaleNECircleElHandler != null) {
    self._selector_ne_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorScaleNECircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorScaleNECircleElHandler = null;
  }
  if (self._touchStartOnSelectorScaleECircleElHandler != null) {
    self._selector_e_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorScaleECircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorScaleECircleElHandler = null;
  }
  if (self._touchStartOnSelectorScaleSECircleElHandler != null) {
    self._selector_se_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorScaleSECircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorScaleSECircleElHandler = null;
  }
  if (self._touchStartOnSelectorScaleSCircleElHandler != null) {
    self._selector_s_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorScaleSCircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorScaleSCircleElHandler = null;
  }
  if (self._touchStartOnSelectorScaleSWCircleElHandler != null) {
    self._selector_sw_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorScaleSWCircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorScaleSWCircleElHandler = null;
  }
  if (self._touchStartOnSelectorScaleWCircleElHandler != null) {
    self._selector_w_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorScaleWCircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorScaleWCircleElHandler = null;
  }
  if (self._touchStartOnSelectorScaleNWCircleElHandler != null) {
    self._selector_nw_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorScaleNWCircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorScaleNWCircleElHandler = null;
  }
  if (self._touchStartOnSelectorRotateCircleElHandler != null) {
    self._selector_r_circle_el?.removeEventListener(
      "touchstart",
      self._touchStartOnSelectorRotateCircleElHandler,
      {
        passive: false,
      }
    );
    self._touchStartOnSelectorRotateCircleElHandler = null;
  }
  if (self._touchMoveHandler != null) {
    self._window.removeEventListener("touchmove", self._touchMoveHandler, {
      passive: false,
    });
    self._touchMoveHandler = null;
  }
  if (self._touchEndOrCancelHandler != null) {
    self._window.removeEventListener(
      "touchend",
      self._touchEndOrCancelHandler,
      {
        passive: false,
      }
    );
    self._window.removeEventListener(
      "touchcancel",
      self._touchEndOrCancelHandler,
      {
        passive: false,
      }
    );
    self._touchEndOrCancelHandler = null;
  }
  if (self._canvas_el != null) {
    self._container_el?.removeChild(self._canvas_el);
  }
  self._container_el = null;
  self._canvas_el = null;
  self._dummy_g_el = null;
  self._layers_el = null;
  self._art_board_layer_el = null;
  self._working_layer_el = null;
  self._foreground_layer_el = null;
  self._rubber_band_layer_el = null;
  self._path_editor_layer_el = null;
  self._art_board_rect_el = null;
  self._art_board_filter_el = null;
  self._art_board_filter_drop_shadow_el = null;
  self._art_board_clip_path_el = null;
  self._art_board_clip_path_shape_path_el = null;
  self._art_board_shape_path_el = null;
  self._selector_path_el = null;
  self._selector_nw_circle_el = null;
  self._selector_n_circle_el = null;
  self._selector_ne_circle_el = null;
  self._selector_e_circle_el = null;
  self._selector_se_circle_el = null;
  self._selector_s_circle_el = null;
  self._selector_sw_circle_el = null;
  self._selector_w_circle_el = null;
  self._selector_r_circle_el = null;
  self._rubber_band_el = null;
  self._path_editor_line_container_el = null;
  self._path_editor_point_container_el = null;
  self._view_port = null;
  self._view_box = null;
  self._working_layer = null;
  self._art_board = null;
  self._selector_controller = null;
  self._rubber_band = null;
  self._grouping = null;
  self._locking = null;
  self._selection = null;
  self._selection_translate_transform = null;
  self._selection_scale_transform1 = null;
  self._selection_scale_transform2 = null;
  self._selection_rotate_transform = null;
  self._translate_transform = null;
  self._scale_transform = null;
  self._stroke = null;
  self._stroke_sync = null;
  self._processing_task = null;
  self._path_editor_target_el = null;
  self._path_editor_list = [];
  self._path_editor_point_size_controller = null;
  self._touchStartOnCanvasElHandler = null;
  self._touchStartOnSelectorPathElHandler = null;
  self._touchStartOnSelectorScaleNCircleElHandler = null;
  self._touchStartOnSelectorScaleNECircleElHandler = null;
  self._touchStartOnSelectorScaleECircleElHandler = null;
  self._touchStartOnSelectorScaleSECircleElHandler = null;
  self._touchStartOnSelectorScaleSCircleElHandler = null;
  self._touchStartOnSelectorScaleSWCircleElHandler = null;
  self._touchStartOnSelectorScaleWCircleElHandler = null;
  self._touchStartOnSelectorScaleNWCircleElHandler = null;
  self._touchStartOnSelectorRotateCircleElHandler = null;
  self._touchMoveHandler = null;
  self._touchEndOrCancelHandler = null;
  self._touch_map = new Map();
  self._selecting_touch_id = null;
  self._translate_transforming_touch_id = null;
  self._scale_transforming1_touch_id = null;
  self._scale_transforming2_touch_id1 = null;
  self._scale_transforming2_touch_id2 = null;
  self._rotate_transforming_origin_x = 0;
  self._rotate_transforming_origin_y = 0;
  self._rotate_transforming_touch_id = null;
  self._zooming_and_panning_touch_id1 = null;
  self._zooming_and_panning_progress_touch_x1 = 0;
  self._zooming_and_panning_progress_touch_y1 = 0;
  self._zooming_and_panning_touch_id2 = null;
  self._zooming_and_panning_progress_touch_x2 = 0;
  self._zooming_and_panning_progress_touch_y2 = 0;
  self._path_editing_touch_id = null;
  self._path_editing_progress_touch_x = 0;
  self._path_editing_progress_touch_y = 0;
};
